<template>
  <div>
    <span v-if="data.column.field === 'published'">
      <div class="d-flex justify-content-between text-align-left">
        <span v-if="data.formattedRow.published">
          <i class="chart-dot-green mr-50" />
          {{ $tk('ClientPortal.Admin.Yes') }}
        </span>
        <span v-else>
          <i class="chart-dot-red mr-50" />
          {{ $tk('ClientPortal.Admin.No') }}
        </span>
        <div class="d-flex align-items-center">
          <b-button
            v-b-modal.modal-create-edit-language
            variant="link"
            class="p-0"
            @click="editLanguageModel(data.row)"
          >
            <GjIcon
              name="Edit"
              class="text-primary"
            />
          </b-button>
          <b-button
            variant="link"
            class="p-0"
            :to="`languages/translate/${data.row.id}`"
          >
            <GjIcon
              name="Language"
              class="text-primary"
            />
          </b-button>
        </div>
      </div>
    </span>
    <span v-else-if="data.column.field === 'name'">
      <b-button
        variant="link"
        :to="`languages/translate/${data.row.id}`"
        size="sm"
      >
        {{ data.formattedRow.name }}
      </b-button>
    </span>

    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import store from '@/store'

export default {
  components: {
    GjIcon,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Array, Object],
    },
  },
  setup() {
    const editLanguageModel = language => store.commit('SET_LANGUAGE_MODEL', language)
    return { editLanguageModel }
  },
}
</script>
